import VideoList from 'gatsby-theme-husky/src/components/VideoList/VideoList';
import './VideoListOverride.scss';

export default VideoList;
